export default __webpack_public_path__ + "static/media/piper-indian.cbdf4f78.jpg";